export default __webpack_public_path__ + "static/media/rs_school_js.ad178c0d.svg";